import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full rounded-md flex flex-col ring-1 ring-inset ring-gray-300" }
const _hoisted_2 = {
  key: 0,
  class: "flex w-full h-10 px-2 border-b border-gray-300"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "dropdown inline-block relative border-gray-300 border-l border-r" }
const _hoisted_6 = { class: "mr-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current h-4 w-4",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" })
], -1)
const _hoisted_8 = { class: "w-32" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "flex border-gray-300 border-r" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "flex border-gray-300 border-r" }
const _hoisted_15 = { class: "flex border-gray-300 border-r" }
const _hoisted_16 = { class: "w-full h-40 px-4 py-4 outline-none" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]

import { ref, computed, onBeforeUnmount } from "vue";
import StarterKit from '@tiptap/starter-kit'
import { EditorContent, Editor } from '@tiptap/vue-3';

import EditorIcons from "@/components/global/EditorIconsComponent.vue";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RichTextComponent',
  props: {
  modelValue: {
    type: String,
    default: ''
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

let isDropdownOpen = ref(false);

const headerOptions = ref([
  { label: 'Header 1', value: 1, font: 'text-2xl' },
  { label: 'Header 2', value: 2 },
  { label: 'Header 3', value: 3 },
  { label: 'Header 4', value: 4 },
  { label: 'Header 5', value: 5 },
  { label: 'Header 6', value: 6 },
])





const editor = new Editor({
  content: props.modelValue,
  extensions: [
    StarterKit,
  ],
  onUpdate({ editor }) {
    emit('update:modelValue', editor.getHTML());
  },
});

onBeforeUnmount(() => {
  editor.destroy();
});

const activeElement = computed(() => {
  // Check if the paragraph is active
  if (editor.isActive('paragraph')) {
      return 'Paragraph';
    }

    // Check for each heading level
    for (const option of headerOptions.value) {
      if (editor.isActive('heading', { level: option.value })) {
        return `Header ${option.value}`;
      }
    }

    return 'Dropdown'; // default text
});

function handleParagraphClick() {
  editor.chain().focus().setParagraph().run();
  isDropdownOpen.value = false;
}

function handleHeaderClick(level: any) {
  editor.chain().focus().toggleHeading({ level }).run();
  isDropdownOpen.value = false;
}

onMounted(() => {
  console.log('heading', activeElement);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(editor))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: "h-10 w-10 flex items-center justify-center",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(editor).chain().focus().undo().run())),
              disabled: !_unref(editor).can().chain().focus().undo().run()
            }, [
              _createVNode(EditorIcons, { type: 'undo' })
            ], 8, _hoisted_3),
            _createElementVNode("button", {
              type: "button",
              class: "h-10 w-10 flex items-center justify-center",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(editor).chain().focus().redo().run())),
              disabled: !_unref(editor).can().chain().focus().redo().run()
            }, [
              _createVNode(EditorIcons, { type: 'redo' })
            ], 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                onFocusin: _cache[2] || (_cache[2] = ($event: any) => (_isRef(isDropdownOpen) //@ts-ignore
 ? isDropdownOpen.value = true : isDropdownOpen = true)),
                type: "button",
                class: "bg-transparent text-gray-700 font-semibold py-2 px-4 rounded inline-flex items-center"
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(activeElement.value), 1),
                _hoisted_7
              ], 32),
              _createElementVNode("ul", {
                class: _normalizeClass(["dropdown-menu absolute text-gray-700 pt-1 z-10", {'hidden': !_unref(isDropdownOpen)}])
              }, [
                _createElementVNode("li", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleParagraphClick()), ["stop"])),
                    class: _normalizeClass([{ 'bg-gray-200': _unref(editor).isActive('paragraph') }, "w-full rounded-t bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"])
                  }, " paragraph ", 2)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerOptions.value, (header) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "w-32",
                    key: header.value
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _withModifiers(($event: any) => (handleHeaderClick(header.value)), ["stop"]),
                      class: _normalizeClass([{ 'is-active': _unref(editor).isActive('heading', { level: header.value }) }, "w-full bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"])
                    }, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(header.label), 1)
                    ], 10, _hoisted_9)
                  ]))
                }), 128))
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["h-10 w-10 flex items-center justify-center", { 'bg-gray-200': _unref(editor).isActive('bold') }]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(editor).chain().focus().toggleBold().run())),
                disabled: !_unref(editor).can().chain().focus().toggleBold().run()
              }, [
                _createVNode(EditorIcons, { type: 'bold' })
              ], 10, _hoisted_12),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["h-10 w-10 flex items-center justify-center", { 'bg-gray-200': _unref(editor).isActive('italic') }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(editor).chain().focus().toggleItalic().run())),
                disabled: !_unref(editor).can().chain().focus().toggleItalic().run()
              }, [
                _createVNode(EditorIcons, { type: 'italic' })
              ], 10, _hoisted_13)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["h-10 w-10 flex items-center justify-center", { 'bg-gray-200': _unref(editor).isActive('bulletList') }]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(editor).chain().focus().toggleBulletList().run()))
              }, [
                _createVNode(EditorIcons, { type: 'ul' })
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["h-10 w-10 flex items-center justify-center", { 'bg-gray-200': _unref(editor).isActive('orderedList') }]),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(editor).chain().focus().toggleOrderedList().run()))
              }, [
                _createVNode(EditorIcons, { type: 'ol' })
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["h-10 w-10 flex items-center justify-center", { 'bg-gray-200': _unref(editor).isActive('codeBlock') }]),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(editor).chain().focus().toggleCodeBlock().run()))
              }, [
                _createVNode(EditorIcons, { type: 'code' })
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["h-10 w-10 flex items-center justify-center", { 'bg-gray-200': _unref(editor).isActive('blockquote') }]),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(editor).chain().focus().toggleBlockquote().run()))
              }, [
                _createVNode(EditorIcons, { type: 'blockquote' })
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_unref(EditorContent), {
          editor: _unref(editor),
          style: {"outline":"none","height":"100%","overflow-y":"scroll"}
        }, null, 8, ["editor"])
      ])
    ]),
    (_unref(editor) && false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(editor).chain().focus().toggleStrike().run())),
            disabled: !_unref(editor).can().chain().focus().toggleStrike().run(),
            class: _normalizeClass({ 'is-active': _unref(editor).isActive('strike') })
          }, " strike ", 10, _hoisted_18),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(editor).chain().focus().toggleCode().run())),
            disabled: !_unref(editor).can().chain().focus().toggleCode().run(),
            class: _normalizeClass({ 'is-active': _unref(editor).isActive('code') })
          }, " code ", 10, _hoisted_19),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(editor).chain().focus().unsetAllMarks().run()))
          }, " clear marks "),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(editor).chain().focus().clearNodes().run()))
          }, " clear nodes "),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(editor).chain().focus().setHorizontalRule().run()))
          }, " horizontal rule "),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(editor).chain().focus().setHardBreak().run()))
          }, " hard break ")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})